import React from "react";
import CalendarDetail from "../../component/Calendar";

const Calendar: React.FC = () => {
  return (
    <>
      <CalendarDetail />
    </>
  );
};
export default Calendar;
